<div *ngIf="loading$ | async" class="loading-overlay">
  <div></div>

  <div class="loading-container">
    <div class="spinner"></div>
    <p>Carregando</p>
  </div>

  <div class="logo-container">
    <img alt="Logo SESI" src="../../../assets/images/Logo SESI.svg">
  </div>
</div>
